<template>
  <div class="container">
    <div class="row">
      <div class="col-md-9">
        <div class="card">
          <iframe
            style="width: 100%; height: 500px; frameborder: 0; allow: autoplay; encrypted-media: allowfullscreen"
            :srcdoc="embedCode"
          />
          <div>
            <header class="flex items-center justify-between py-1 px-4 lg:px-6 lg:border-b border-b-0">
              <div>
                <h3
                  class="lg:text-2xl text-xl line-clamp"
                  style="color: rgb(35, 83, 255);"
                >
                  {{ titluoConteudo }}
                </h3></div>
              <div class="flex items-center flex-shrink-0 flex-grow-0">
                <div class="mr-4">
                  <div class="flex items-center" />
                </div>
              </div>
            </header>
            <div class="flex items-center justify-between py-1 px-4 lg:px-6 lg:border-b border-b-0">
              <div class="mt-8 mb-8 px-8"><!---->
                <div
                  class="prose-sm prose-non-premium prose lg:prose-lg w-full"
                  style="max-width: 100% !important;"
                >
                  <p v-html="conteudoContent" /></div>
              </div>
              <div
                v-if="files.length !== 0"
                class="mt-16 mb-8 px-8"
              >
                <h2 class="text-gray-500 mt-16 text-xs font-medium uppercase tracking-wide">
                  Anexos
                </h2>
                <div class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                  <div
                    v-for=" item in files"
                    :key="item.id"
                  >
                    <a
                      target="_blank"
                      class="col-span-1 flex shadow-sm rounded-md cursor-pointer"
                      style="display: flex;"
                      @click="download(item)"
                    >
                      <div
                        style="display: flex;"
                        class="flex-shrink-0 flex items-center uppercase justify-center w-16 bg-pink-600 text-white text-sm leading-5 font-medium rounded-l-md"
                      >
                        {{ item.type }}
                      </div>
                      <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                      >
                        <div class="flex-1 px-4 py-2 text-sm leading-5 truncate"><span
                          class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                        >{{ item.name }}</span>
                          <!--                          <p class="text-gray-500">-->
                          <!--                            0.01 MB-->
                          <!--                          </p>-->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          v-for="(module, index) in [conteudoModulo]"
          :key="index"
          class="card no-gutters "
        >
          <div class="row justify-content-center input-container">
            <div class="d-flex align-items-center">
              <div
                class="flex-grow-1"
                style="margin-right: 25px;"
              >

                <h2><strong>{{ module.modulo_name }}</strong></h2>
              </div>
            </div>
          </div>
          <button
            class="collapsible"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse_${module.id}`"
            :aria-expanded="index === 0 ? 'true' : 'false'"
            :aria-controls="`collapse_${index}`"
          />
          <div
            v-for="(content, contentIndex) in module.conteudo"
            :id="`collapse_${module.id}`"
            :key="contentIndex"
            :class="{ show: index === 0 }"
            class="content"
            :style="{ maxHeight: '100%', cursor: 'pointer' }"
            @click="videoUrl(content)"
          >
            <div
              class="row justify-content-center input-container"
            >
              <div class="d-flex align-items-center">
                <div class="form-check-inline" />
                <div class="flex-grow-1">
                  <h4>{{ content.titulo }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BEmbed } from 'bootstrap-vue'
import CollapseTreinamento from '@/views/App/Treinamentos/Vsl-Booster/CollapseTreinamento.vue'
import ConteudoService from '@/services/Conteudo'
import router from '@/router'
import axios from 'axios'

const conteudoService = new ConteudoService()
export default {
  components: {
    BEmbed,
    CollapseTreinamento,
  },
  model: {
    prop: 'modulosConteudos',
    event: 'modulosConteudos',
  },
  props: {
    modulosConteudos: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      files: [],
      video: '',
      titluoConteudo: '',
      conteudoContent: '',
      embedCode: '',
    }
  },
  computed: {
    conteudoModulo: {
      get() {
        if (this.modulosConteudos) {
          return this.modulosConteudos
        }
        return {}
      },
      set(value) {
        this.$emit('modulosConteudos', value)
      },
    },
  },
  watch: {
    modulosConteudos: {
      handler(newValue) {
        if (newValue) {
          this.video = this.modulosConteudos.conteudo[0].conteudo_video_url || ''
          this.titluoConteudo = this.modulosConteudos.conteudo[0].titulo || ''
          this.conteudoContent = this.modulosConteudos.conteudo[0].content || ''
          this.files = this.modulosConteudos.conteudo[0].files || []
          this.embedCode = this.modulosConteudos.conteudo[0].embedCode || ''
        }
      },
      deep: true,
    },
  },
  methods: {
    async getConteuById() {
      await conteudoService.ConteudoByIdModulo(this.conteudoModulo.id)
        .then(res => {
          this.video = res.conteudo_video_url || ''
          this.titluoConteudo = res.titulo || ''
          this.conteudoContent = res.content || ''
          this.files = res.files || []
          this.embedCode = response.embedCode || ''
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    videoUrl(Url) {
      this.video = Url.conteudo_video_url || ''
      this.titluoConteudo = Url.titulo || ''
      this.conteudoContent = Url.content || ''
      this.files = Url.files || []
      this.embedCode = Url.embedCode || ''
    },

    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    download(item) {
      axios({
        method: 'get',
        url: item.url,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response, item.name)
        })
        .catch(() => console.log('error occured'))
    },
  },

}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/cardfile.scss';
@import "@/assets/scss/vslTreinamento.scss";
</style>
